import gql from 'graphql-tag';

export default gql`
  query getListSalePICByTeam($input: GetListSalePICByTeamInput!) {
    getListSalePICByTeam(input: $input) {
      totalResults
      totalPage
      data {
        id
        name
        phone
      }
    }
  }
`;
